// @flow
export { default } from './FooterIndicator';
